import { Typography, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AboutDigitization() {
  const [images, setImages] = useState(1);
  const [curves, setCurves] = useState(1);
  const [feet, setFeet] = useState(1);
  const [quote, setQuote] = useState('');
  const [quoteValue, setQuoteValue] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          const navbarHeight = 80; // Approximate navbar height
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth'
          });
        }, 100);
      }
    } else {
      // If no hash, scroll to top immediately
      window.scrollTo(0, 0);
    }
  }, [location]);

  const handleSubmit = () => {
    const raw = (images * 20) + (images * curves * feet) * 0.0015;
    const roundedUp = Math.ceil(raw * 100) / 100;
    const formattedNumber = roundedUp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    setQuote(`$${formattedNumber}`);
    setQuoteValue(roundedUp);
  };
  const handleReset = () => {
    setImages(1);
    setCurves(1);
    setFeet(1);
    setQuote('');
    setQuoteValue(0);
  };    

  return (
    <div
      style={{ width: '100%', background: '#000', boxSizing: 'border-box', padding: '0 max(24px, calc((100vw - 1300px) / 2)) 50px' }}>
      <div style={{width: '100%', minWidth: '1300px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
          flexWrap: 'nowrap', gap: 'clamp(25px, 5vw, 30px)', flexDirection: 'column' }}>
        <div style={{ width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom
            style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '3rem', fontWeight: 500, marginTop: '110px', textAlign: 'center' }}>
            Log Digitization
          </Typography>
        </div>
          {/* Responsive two-column layout: paragraph on the left, calculator on the right */}
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', gap: '25px', 
            minHeight: '260px', width: '100%', boxSizing: 'border-box', padding: '0 max(calc((25vw - 1300px) / 2))' }}>
          <div>
            <Typography variant="body1" paragraph
              style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, marginTop: '35px',
                textAlign: 'left', maxWidth: '600px' }}>
                Our base pricing starts with a $20 USD flat fee charged to every log image digitized and an additional $0.002 USD per ft digitized. <br /><br />
                Want to see how affordable our pricing is? Use our instant quote tool to find out for yourself.<br /><br />
                Don't forget to ask about our bulk volume discounts for even lower pricing.
            </Typography>
          </div>
          <div style={{ flex: '0 0 650px' }}>
            <div style={{
              background: "url('/CALC_BACKGROUND_RIG.jpeg')", backgroundSize: '75%',
              backgroundPosition: 'center 75%', color: '#ffffffff',
              boxShadow: '0 4px 16px rgba(0,0,0,0.10)', margin: '0 auto',
              padding: '32px', fontFamily: 'Inter, sans-serif', fontSize: '1.5rem', fontWeight: 500,
              borderRadius: '12px', border: '2px solid #ffffffff', }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ textAlign: 'left', flex: 1 }}>Number of image files:</span>
                <input type="number" value={images} min={1} step={1} inputMode="numeric" pattern="[0-9]*"
                  onChange={e => setImages(Math.max(1, Math.floor(Number(e.target.value) || 1)))}
                  style={{marginLeft: '16px', color: '#ffffffff', padding: '6px 12px',
                    border: '1px solid #ffffffff', borderRadius: '5px', fontSize: '1rem',
                    background: '#000000ff', width: '120px'}}/>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ textAlign: 'left', flex: 1 }}>Number of curves per image:</span>
                <input type="number" value={curves} min={1} step={1} inputMode="numeric" pattern="[0-9]*"
                  onChange={e => setCurves(Math.max(1, Math.floor(Number(e.target.value) || 1)))}
                  style={{marginLeft: '16px', color: '#ffffffff', padding: '6px 12px',
                    border: '1px solid #ffffffff', borderRadius: '5px', fontSize: '1rem',
                    background: '#000000ff', width: '120px' }}/>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
                <span style={{ textAlign: 'left', flex: 1 }}>Number of ft per curve:</span>
                <input type="number" value={feet} min={1} step={1} inputMode="numeric" pattern="[0-9]*"
                  onChange={e => setFeet(Math.max(1, Math.floor(Number(e.target.value) || 1)))}
                  style={{marginLeft: '16px', color: '#ffffffff', padding: '6px 12px',
                    border: '1px solid #ffffffff', borderRadius: '5px', fontSize: '1rem',
                    background: '#000000ff', width: '120px'}}/>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'flex-start' }}>
                  <span style={{ textAlign: 'left', color: '#ffffffff', fontSize: '1.5rem', fontWeight: 500 }}>
                    Instant quote:
                  </span>
                  <input type="text" readOnly value={quote}
                    style={{marginLeft: '12px', padding: '6px 12px', border: '1px solid #ffffffff',
                      background: '#000000ff', fontFamily: 'Inter, sans-serif', fontSize: '1.5rem',
                      fontWeight: 500, color: '#ffffffff',  width: '150px', borderRadius: '5px' }}/>
                </div>
                <button
                  style={{ background: '#ffffffff', color: '#000', border: 'none', borderRadius: '6px', padding: '10px 28px', fontSize: '1.1rem', fontWeight: 700, cursor: 'pointer', transition: 'background 0.2s' }}
                  onMouseDown={e => e.currentTarget.style.background = '#8d8c8cff'}
                  onMouseUp={e => e.currentTarget.style.background = '#ffffffff'}
                  onMouseLeave={e => e.currentTarget.style.background = '#ffffffff'}
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  style={{ marginLeft: '16px', background: '#ffffffff', color: '#000', border: 'none', borderRadius: '6px', padding: '10px 28px', fontSize: '1.1rem', fontWeight: 700, cursor: 'pointer', transition: 'background 0.2s' }}
                  onMouseDown={e => e.currentTarget.style.background = '#8d8c8cff'}
                  onMouseUp={e => e.currentTarget.style.background = '#ffffffff'}
                  onMouseLeave={e => e.currentTarget.style.background = '#ffffffff'}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
              {quote && (
                <div style={{marginTop: '20px', textAlign: 'center', color: '#ffffffff',
                  fontFamily: 'Inter, sans-serif', fontSize: '1.2rem', fontWeight: 400 }}>
                  Total: ({images} × $20) + ({images} × {curves} × {feet} × $0.002)
                </div>
              )}
              {quoteValue > 10000 && quoteValue < 25000 && (
                <div style={{ marginTop: '18px', textAlign: 'center', color: '#ffffffff', fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 700 }}>
                  Reach out for bulk volume pricing
                </div>
              )}
              {quoteValue > 25000 && (
                <div style={{ marginTop: '18px', textAlign: 'center', color: '#ffffffff', fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 700 }}>
                  Reach out about our enterprise pricing.
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{ width: '100%', maxWidth: '1600px', margin: '24px auto', display: 'flex', justifyContent: 'center' }}>
          <div style={{ height: '1px', background: '#ffffff', opacity: 0.9, width: '90%' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', width: '100%', 
          boxSizing: 'border-box', padding: '0 max(calc((25vw - 1300px) / 2))' }}>
          <div style= {{ width: '100%'}}>
            <Typography
              id="geotech-services" variant="h4" component="h1" gutterBottom
              style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '3rem', fontWeight: 500, textAlign: 'center' }}>
              Geotech and Database Management Services
            </Typography>
          </div>          
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', gap: '25px', minHeight: '350px',
           width: '100%', boxSizing: 'border-box', padding: '0 max(calc((25vw - 1300px) / 2))' }}>
            <div>
              <Typography variant="body1" paragraph
                style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, marginTop: '35px',
                textAlign: 'left', maxWidth: '600px' }}>
                Whether you need help depth registering logs, renaming rasters to a common naming convention, or building a comprehensive geoscience database, we have you covered.<br /><br />
                Depth registering and renaming logs starts at just $2 USD per log.<br /><br />Other services are priced on a case-by-case basis depending on the scope of work.
                Contact us today to discuss your specific needs and get a custom quote.
              </Typography>
            </div>
            <div style={{ flex: '0 0 650px' }}>
              <img src="/Net_Sand_Isopach_Map-cropped.png" alt="NetSand" style={{ width: '100%', borderRadius: '8px' }}/>
            </div>
          </div>
          <div style={{ width: '100%', maxWidth: '1600px', margin: '24px auto', display: 'flex', justifyContent: 'center' }}>
            <div style={{ height: '1px', background: '#ffffff', opacity: 0.9, width: '90%' }} />
          </div>        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', width: '100%', 
          boxSizing: 'border-box', padding: '0 max(calc((25vw - 1300px) / 2))' }}>
          <div style= {{ width: '100%'}}>
            <Typography id="custom-solutions" variant="h4" component="h1"
              style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '3rem', fontWeight: 500, textAlign: 'center' }}>
              Custom Solutions
            </Typography>
          </div>          
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', gap: '25px', minHeight: '350px',
           width: '100%', boxSizing: 'border-box', padding: '0 max(calc((25vw - 1300px) / 2))' }}>
          <div>
            <Typography variant="body1" paragraph
              style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, textAlign: 'left', maxWidth: '600px' }}>
                The world of AI is rapidly evolving and we are here to help you leverage the latest advancements to solve your unique challenges. From automating tedious tasks to building custom machine learning models, we can help you harness the power of AI to drive efficiency and innovation in your organization.<br /><br />
                Contact us today to discuss your specific needs and explore how we can work together to create custom AI solutions that deliver real value.          
            </Typography>
          </div>
          <div style={{ flex: '0 0 650px' }}>
            <img src="/Whisk-Custom-solutions.png" alt="Section" style={{ width: '100%', borderRadius: '8px' }}/>
          </div>
        </div>
      </div>
    </div>
  );
}
